<template>
  <div>
    <Table
      resource="ParentCategory"
      :actions="actions"
      :items="$store.getters['parentCategory/tableData']"
      :detail="$store.getters['parentCategory/detailData']"
      :fields="$store.getters['parentCategory/tableFields']"
      :pagination="$store.state.parentCategory.tablePagination"
      :keyword="$store.state.parentCategory.tableKeyword"
      :loading="$store.state.parentCategory.loadingTable"
      :filter="$store.state.parentCategory.tableFilter"
      :sort="$store.state.parentCategory.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('parentCategory/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('parentCategory/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('parentCategory/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('parentCategory/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('parentCategory/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('parentCategory/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('parentCategory/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('parentCategory/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('parentCategory/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('parentCategory/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
